/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";

import { FOLDERS } from "../doseeData/utils/Utils";
import { ImageKitUpload } from "../../ui/ImageKitLibrary";
import { useCountryContext } from "../../context/CountryContext";
import {
  TextArea,
  MyMessage,
  InputField,
  PhoneInput,
  SearchSelectInput,
  PasswordField,
  AddPageShell,
  AddSection,
} from "../components/Component";
import { defaultImage } from "../../lib/libraries/imageKit/ImageKit";
import { useAdminContext } from "../../context/admin/AdminContext";
import {
  FiBriefcase,
  FiImage,
  FiUser,
  FiAlignLeft,
  FiGlobe,
} from "react-icons/fi";

const Add = () => {
  const { superAdminCreateCompany } = useAdminContext();
  const { countries, fetchCountries } = useCountryContext();

  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const [name, setName] = useState(null);
  const [firstName, setFirstName] = useState(null);
  const [lastName, setLastName] = useState(null);
  const [password, setPassword] = useState(null);
  const [country, setCountry] = useState<any>("Uganda");
  const [website, setWebsite] = useState(null);
  const [email, setEmail] = useState(null);
  const [phoneNumber, setPhoneNumber] = useState(null);
  const [message, setErrorMessage] = useState<any>(null);
  const [thumbnail, setThumbnail] = useState(defaultImage);
  const [thumbnailId, setThumbnailId] = useState("img_cdn_id");
  const [description, setDescription] = useState(null);

  const companyRoutes = "/company";

  useEffect(() => {
    if (!countries) fetchCountries();
  }, [countries, country]);

  const cleanFields = () => {
    setLoading(false);
    setSuccess(true);
    setThumbnail(null);
    setThumbnailId(null);
    setDescription(null);
    setName(null);
    setWebsite(null);
    setCountry(null);
    setFirstName(null);
    setLastName(null);
    setEmail(null);
    setPassword(null);
  };

  const responses = (isError: any, successState: any, msg: any) => {
    setLoading(false);
    setError(isError);
    setSuccess(successState);
    setErrorMessage(msg);
  };

  const addOneCompanyHandler = async (e: any) => {
    e.preventDefault();
    setLoading(true);
    if (!thumbnail || !thumbnailId) {
      responses(true, false, "Image Required");
    } else if (!isValid({ data: countries, value: country, key: "name" })) {
      responses(true, false, "Invalid Country");
    } else await sendDBRequest();
  };

  const sendDBRequest = async () => {
    const data = {
      name,
      thumbnail,
      image_cdn_id: thumbnailId,
      description,
      website,
      email,
      first_name: firstName,
      last_name: lastName,
      password,
      phonenumber: phoneNumber,
      country,
    };

    const { message: msg, status } = await superAdminCreateCompany(data);
    if (status === 200 || status === 201) {
      cleanFields();
      responses(false, true, msg);
    } else {
      responses(true, false, msg);
    }
  };

  const isValid = ({ data, value, key }: any) =>
    data?.find((x: any) => (x?.[key] === value ? true : false));

  return (
    <AddPageShell
      backRoute={companyRoutes}
      eyebrow="Tenants • Companies"
      title="Add New Company"
      subtitle="Create a new tenant with brand assets and a primary admin account."
      icon={<FiBriefcase className="h-5 w-5" />}
      loading={loading}
      submitLabel="Add New Company"
      onSubmit={addOneCompanyHandler}
      onSubmitClick={() => {
        setError(false);
        setSuccess(false);
        setErrorMessage(null);
      }}
      message={
        <MyMessage
          error={error}
          message={message}
          success={success}
          onExpired={() => {
            setError(false);
            setSuccess(false);
          }}
          onClick={() => {
            setError(false);
            setSuccess(false);
            setErrorMessage("");
          }}
        />
      }
    >
      <AddSection
        title="Brand Assets"
        hint="JPG or PNG. Square logos look best."
        icon={<FiImage className="h-4 w-4" />}
      >
        <ImageKitUpload
          thumbnail={thumbnail}
          thumbnailId={thumbnailId}
          setThumbnail={setThumbnail}
          setThumbnailId={setThumbnailId}
          folder={FOLDERS.COMPANY}
        />
      </AddSection>

      <AddSection
        title="Company Details"
        hint="Public-facing identity and home country."
        icon={<FiGlobe className="h-4 w-4" />}
      >
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
          <InputField
            props={{
              id: "company_name",
              title: "Company Name",
              type: "text",
              value: name ? name : "",
              required: true,
              onChange: (e: any) => {
                setName(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
          <InputField
            props={{
              id: "website",
              title: "Company Website",
              type: "text",
              required: true,
              value: website ? website : "",
              onChange: (e: any) => {
                setWebsite(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
          <SearchSelectInput
            title="Country"
            value={country ? country : null}
            required
            options={countries ? countries?.map((x: any) => x?.name) : []}
            onChange={(v: any) => setCountry(v)}
          />
        </div>
      </AddSection>

      <AddSection
        title="Primary Admin"
        hint="The first admin who can sign in and invite teammates."
        icon={<FiUser className="h-4 w-4" />}
      >
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
          <InputField
            props={{
              id: "first_name",
              title: "First Name",
              required: true,
              type: "text",
              value: firstName ? firstName : "",
              onChange: (e: any) => {
                setFirstName(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
          <InputField
            props={{
              id: "last_name",
              title: "Last Name",
              type: "text",
              value: lastName ? lastName : "",
              required: true,
              onChange: (e: any) => {
                setLastName(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
          <InputField
            props={{
              id: "email",
              title: "Email Address",
              type: "text",
              value: email ? email : "",
              required: true,
              onChange: (e: any) => {
                setEmail(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
          <PhoneInput
            setPhone={setPhoneNumber}
            phone={phoneNumber}
            required={true}
            country={country}
          />
          <PasswordField
            value={password || ""}
            onChange={(e: any) => {
              setPassword(e.target.value);
              setError(null);
              setSuccess(null);
            }}
            disabled={loading}
            required={true}
          />
        </div>
      </AddSection>

      <AddSection
        title="Description"
        hint="A short summary about the company."
        icon={<FiAlignLeft className="h-4 w-4" />}
      >
        <TextArea
          props={{
            id: "description",
            title: "Description",
            type: "text",
            required: true,
            value: description ? description : "",
            onChange: (e: any) => {
              setDescription(e.target.value);
              setError(null);
              setSuccess(null);
            },
          }}
        />
      </AddSection>
    </AddPageShell>
  );
};

export default Add;
